export default {
  exemptionData(state, value) {
    return (state.exemptionData = value);
  },
  exemptionTotal(state, total) {
    return (state.exemptionTotal = total);
  },
  exemptionApprovalTotal(state, total) {
    return (state.exemptionApprovalTotal = total);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  employees(state, value) {
    return (state.employees = value);
  },
  branches(state, value) {
    return (state.branches = value);
  },
  filterValue(state, value) {
    return (state.filterValue = value);
  },
  filterDate(state, value) {
    return (state.filterDate = value);
  },
  approvalsData(state, value) {
    return (state.approvalsData = value);
  },
  approvalData(state, value) {
    return (state.approvalData = value);
  },
  currentApproval(state, approvalData) {
    return (state.currentApproval = approvalData);
  },
  departments(state, value) {
    return (state.departments = value);
  },
  employeeGrades(state, value) {
    return (state.employeeGrades = value);
  },
  currentExemption(state, exemptionData) {
    return (state.currentExemption = exemptionData);
  },
};
